const dictionaries = {
  total: 'other.total',
  record: 'other.record',
  item: 'other.item1'
}

export { dictionaries }
